module.exports = __webpack_public_path__ + "static/media/trucks.984b6a08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/trucks.svg
// module id = 1413
// module chunks = 0